import styled from 'styled-components';
import { EnumFilterTheme } from '../../../../../tools/typings/styled-components';
import { ChevronDown } from '../../../../common/components/icons/outlined/ChevronDown';
import { ChevronUp } from '../../../../common/components/icons/outlined/ChevronUp';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { FontWeight, FONT_STACK, LINK_STYLE } from '../../../../common/styles/constants';

export const DrawerEnumFilterContainer = styled.div`
  margin: 18px 0 40px;
`;

export const ShowButton = styled.p`
  ${FONT_STACK}
  ${LINK_STYLE};
  align-items: center;
  display: flex;
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 16px;
  margin: 20px 0 0;
  width: 110px;
`;

export const StyledChevronUp = styled(ChevronUp)`
  fill: ${ThemeColours.primary};
  height: 16px;
  width: 16px;
`;

export const StyledChevronDown = styled(ChevronDown)`
  fill: ${ThemeColours.primary};
  height: 16px;
  width: 16px;
`;

export const DrawerEnumFilterTheme: EnumFilterTheme = {
  titleMargin: '0 0 16px 0',
  captionMargin: '0',
  optionGroupMargin: '0',
  optionPadding: '8px 0',
  titleFontSize: '20px',
};
